import React, {Component} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../CSS/LoginPage.css';
//import Promise from 'promise-polyfill';
import AuthService from '../utils/AuthService.js';
import CreateAccount from './CreateAccount.js';
import { Switch, Route, Link } from 'react-router-dom'
import FacebookLogin from 'react-facebook-login';
import logo from '../images/logo.png'
import Linkify from 'react-linkify';


// if (!window.Promise) {
//   window.Promise = Promise;
// }

class LoginForm extends Component {

  constructor(props) {
    super(props);
    this.Auth = new AuthService()

    this.state = {
      email: "",
      password: ""
    };
    this.responseFacebook = this.responseFacebook.bind(this)
    this.createGuestAccount = this.createGuestAccount.bind(this)
    this.uuid = this.uuid.bind(this)
  }
  responseFacebook(response){
    var email= response.email
    var facebookProfile = response.link
    var uid = response.userID
    this.Auth.facebookLogin(email, facebookProfile, uid)
    .then(res =>{
                window.location.href = '../';
            })
              .catch(err =>{
                  alert(err);
              })
  }
  // responseFacebook = (response) => {
  //     console.log(response);
  // }
  validateForm(){
    return this.state.email.length > 0 && this.state.password.length > 0;
  }
  createGuestAccount() {
    var random = this.uuid()
    var email = "web-" + random + "@genericuser.getspiffy.com"
    var password = this.uuid()
    this.Auth.createAccount(email,password)
          .then(res =>{
            if(res.errors){
              this.setState({
                error: res.errors
              })
            }
            else {

              localStorage.setItem('id_token', res.auth_token) // Setting the token in localStorage
              localStorage.setItem('customer_id', res.id)
              window.location.href = '../'
            }
          })
          .catch(err =>{
              alert(err);
          })
  }
  uuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
  });
}
  handleChange = event => {
      this.setState({
        [event.target.id]: event.target.value
      });
  }
  handleSubmit = event => {
    event.preventDefault()
    this.Auth.login(this.state.email,this.state.password)
          .then(res =>{
            if(res.errors){
                if(res.errors === 'Admin User') {
                    this.setState({
                        error: `Your account is an admin user and can only be used to login to the admin portal at: ${this.getRedirectURL()}admin`
                    })
                } else if (res.errors === 'Fleet User') {
                    this.setState({
                        error: `Your account is an fleet user and can only be used to login to the fleet portal at: ${this.getRedirectURL()}partners`
                    })
                } else {
                    this.setState({
                        error: res.errors
                    })
                }
            }
            else {
                localStorage.setItem('id_token', res.auth_token) // Setting the token in localStorage
                localStorage.setItem('customer_id', res.id)
                window.location.href = '../'
            }
            //  this.props.history.replace('/');
          })
          .catch(err =>{
              alert(err);
          })
  }

  getRedirectURL = () => {
      var loc = window.location;
      var url = new URL(loc)
      var enviorment_url = url.hostname

      if(enviorment_url == "booking-staging.getspiffy.com"){
          return "https://staging.getspiffy.com/"
      }
      else if(enviorment_url == "booking.getspiffy.com"){
          return "https://my.getspiffy.com/"
      }
      else {
          return "https://getspiffy.test/"
      }
  }

    render(){
      var url = this.Auth.getBaseUrl()
      return (
          <div className="container-fluid vertical-align loginContainer">
            <div className="row">
              <div className="offset-lg-2 col-lg-8 content">
                <div className="card-body loginCard text-center bg-dark">
                  <img className="mb-2 logo-login" alt ="logo" src={logo}></img>
                  <h6 className="redText"><Linkify>{this.state.error}</Linkify></h6>
                  <form onSubmit={this.handleSubmit}>
                    <div className="form-group">
                      <input className="form-control form-control-md mb-2" type="email" id="email" value={this.state.email} onChange={this.handleChange} placeholder="Email"></input>
                      <input className="form-control form-control-md" type="password" id="password" value={this.state.password} onChange={this.handleChange} placeholder="Password"></input>
                    </div>
                    <div className="form-group">
                      <button className="btn btn-success btn-block text-center" type="submit" disabled={!this.validateForm()}>Login</button>
                      <FacebookLogin
                         appId="1464512357154384"
                         autoLoad={false}
                         fields="name,email,link"
                         isMobile={true}
                         disableMobileRedirect={true}
                         callback={this.responseFacebook}

                          />
                    </div>
                  </form>
                  <div className="mb-2">
                    <a className="text-white" href={url + "customer/password/new"}><small>Forgot Password?</small></a>
                  </div>
                  <div className="row">
                    <div className="col">
                      <button className="btn btn-primary btn-sm float-right" type="button" onClick={this.createGuestAccount}>Explore as Guest!
                      </button>
                    </div>
                  </div>
                    <div className="row"> <p className="text-white" ><small>1.0.0</small></p></div>
                </div>
              </div>
            </div>
          </div>
      )
    }
}
export default LoginForm;



// WEBPACK FOOTER //
// ./src/Components/LoginForm.js